import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4469be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "sms-modal-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { id: "booking-detail-modal-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "modal-footer" }

import $ from 'jquery';
  import _get from 'lodash/get';
  import { ref, computed, onMounted, inject } from 'vue';
  import { useStore } from 'vuex';
  import RevisitDetail from "./RevisitDetail.vue";
  
  // Import your models or other external methods
  import {  Booking, CognitoUser, Dictionary, Landlord, Tenant } from "@/models";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'RevisitDetailModal',
  props: {
    id: String
  },
  setup(__props, { expose: __expose }) {

  const props = __props;
  
  const store = useStore();
  
  const cognitoUser = computed((): CognitoUser => store.getters['auth/cognitoUser']);
  const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
  
  const saveBooking = (booking: Booking) => {
    return store.dispatch("diary/saveBookingFromScheduler", booking);
  };
  
  const realtime: any = inject('realtime');
  const actProperty: any = inject('actProperty');
  
  const channel = realtime.channels.get('diary');
  const deviceid = actProperty.getDeviceId();
  
  const booking = ref(new Booking());
  const showfull = ref(true);
  
  
  const title = ref("");
  const titlenoteschanged = ref(false);
  const bookingid = computed(() => booking.value.id);
  
  // Methods
  const init = (bookingData: Booking, showfullFlag: boolean) => {
    booking.value = bookingData;
    title.value = actProperty.getBookingTitle(booking.value, dictionary.value);
    showfull.value = showfullFlag;
  };
  
  const pischeduler = computed(() => {
    const assignedGroups = _get(
      cognitoUser.value,
      'signInUserSession.accessToken.payload["cognito:groups"]',
      []
    );
    const isDiaryUser = assignedGroups.some(
      (assignedGroup: string) => ["DiaryUser"].includes(assignedGroup)
    );
    return (screen.width <= 760 && isDiaryUser);
  });
  
  const onAddressclick = () => {
    if (pischeduler.value) {
      let address = actProperty.formatAddress(booking.value.address, ", ");
      window.open(`http://maps.google.com/?q=${encodeURI(address)}`, '_blank', 'noreferrer');
    }
  }
  
  
  const show = () => {
    if ($(`#${props.id}` + 'Backdrop').length == 0) {
      const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
      $('body').append(backdropDiv);
      let el = $(`#${props.id}`);
      el.show();
    }
  }
  
  const hide = () => {
    if ($(`#${props.id}`).length > 0) {
      $(`#${props.id}` + 'Backdrop').remove();
    }
    if (titlenoteschanged.value) {
      saveBooking(booking.value).then((b: Booking) => {
        channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: b.id, source: 'Scheduler' });
        $(`#${props.id}`).hide();
      });
    }
    else {
      $(`#${props.id}`).hide();
    }
  };
  
  __expose({ init, show, hide });
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`booking-detail-modal-label`",
    "aria-hidden": "true",
    style: {}
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(title.value), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _withModifiers(hide, ["prevent"])
          }, _hoisted_7)
        ]),
        (_openBlock(), _createElementBlock("div", {
          class: "modal-body",
          key: bookingid.value
        }, [
          _createElementVNode("div", _hoisted_8, [
            (booking.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(RevisitDetail, {
                    booking: booking.value,
                    leadbooking: booking.value.leadbooking
                  }, null, 8, ["booking", "leadbooking"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _withModifiers(hide, ["prevent"])
          }, " Close ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})